import { LeadForm } from '@upright/ui/common/activities/lead-form/lead-form';
import { getLeadForm, LeadFormId } from './types';

interface Props {
  id: LeadFormId;
  inModal: boolean;
  hideTitle?: boolean;
}

export function LeadFormWithId(props: Props) {
  const { id } = props;
  const form = getLeadForm(id);
  return (
    <LeadForm
      formId={form.hubspotId}
      inModal={props.inModal}
      submitText={form.submitText}
      title={form.title}
      textBelowTitle={form.textBelowTitle}
      hideTitle={props.hideTitle}
      hideMessage={form.hideMessage}
      askConsent={form.askConsent}
      contactInfo={form.contact}
      interactionEvent={form.interactionEvent}
      submitEvent={form.submitEvent}
      successMessage={form.successMessage}
      successTitle={form.successTitle}
      showOrganizationTypeField={form.showOrganizationTypeField}
      CustomInputComponent={form.CustomInputComponent}
    />
  );
}
